import React, { useRef } from "react";
import {
  Box,
  Button,
  Avatar,
  Stack,
  FormControlLabel,
  Checkbox,
  darken,
} from "@mui/material";
import PhotoCameraOutlinedIcon from "@mui/icons-material/PhotoCameraOutlined";
import { iresoftColors } from "../../../theme/ireColors";
import { t } from "i18next";

interface PhotoUploaderProps {
  photo: File | null;
  randomPhotoUrl?: string;
  useRandomPhoto: boolean;
  setPhoto: (file: File | null) => void;
  setUseRandomPhoto: (value: boolean) => void;
  handleDrop: (e: React.DragEvent<HTMLDivElement>) => void;
  handleDragOver: (e: React.DragEvent<HTMLDivElement>) => void;
  handleFileInputChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
}

const PhotoUploader: React.FC<PhotoUploaderProps> = ({
  photo,
  randomPhotoUrl,
  useRandomPhoto,
  setPhoto,
  setUseRandomPhoto,
  handleDrop,
  handleDragOver,
  handleFileInputChange,
}) => {
  const fileInputRef = useRef<HTMLInputElement | null>(null);

  return (
    <Stack direction="column" spacing={1}>
      <Stack
        direction="row"
        alignItems="center"
        spacing={2}
        sx={{ height: 45 }}
      >
        <Box
          onDrop={handleDrop}
          onDragOver={handleDragOver}
          sx={{ width: "100%" }}
        >
          <Button
            variant="contained"
            component="label"
            startIcon={<PhotoCameraOutlinedIcon />}
            fullWidth
            disabled={useRandomPhoto}
            sx={{
              textTransform: "none",
              backgroundColor: iresoftColors.salmon100,
              color: iresoftColors.black,
              "&:hover": {
                backgroundColor: darken(iresoftColors.salmon100, 0.15),
              },
            }}
          >
            {t("pages.currentlyReading.form.uploadPhoto")}
            <input
              ref={fileInputRef}
              type="file"
              accept="image/*"
              hidden
              onChange={handleFileInputChange}
            />
          </Button>
        </Box>

        {photo && <Avatar src={URL.createObjectURL(photo)} alt="Foto" />}
        {useRandomPhoto && randomPhotoUrl && (
          <Avatar src={randomPhotoUrl} alt="Random Foto" />
        )}
      </Stack>

      <FormControlLabel
        control={
          <Checkbox
            checked={useRandomPhoto}
            onChange={(e) => setUseRandomPhoto(e.target.checked)}
          />
        }
        label={t("pages.currentlyReading.form.usePlaceholderPhoto")}
      />
    </Stack>
  );
};

export default PhotoUploader;
